// Mantine color names mapping for marina entity statuses.
// Use with Badge color="..." or var(--mantine-color-{name}-{shade}).

export const bookingStatusColor: Record<string, string> = {
  PENDING: 'yellow',
  WAITLISTED: 'gray',
  CONFIRMED: 'blue',
  DECLINED: 'red',
  RESERVED: 'teal',
  CHECKED_IN: 'green',
  CHECKED_OUT: 'gray',
  CANCELLED: 'red',
  NO_SHOW: 'red',
}

export const quoteStatusColor: Record<string, string> = {
  DRAFT: 'yellow',
  SENT: 'orange',
  ACCEPTED: 'green',
  REJECTED: 'red',
  EXPIRED: 'gray',
  CONVERTED: 'blue',
}

export const invoiceStatusColor: Record<string, string> = {
  PRO_FORMA: 'yellow',
  DRAFT: 'gray',
  SENT: 'blue',
  PARTIALLY_PAID: 'cyan',
  PAID: 'green',
  OVERDUE: 'red',
  CANCELLED: 'gray',
}

export const contractStatusColor: Record<string, string> = {
  DRAFT: 'gray',
  PREPARED: 'cyan',
  PENDING_REVIEW: 'yellow',
  ACTIVE: 'green',
  EXPIRED: 'gray',
  TERMINATED: 'red',
}

export const customerCategoryColor: Record<string, string> = {
  TRANSIT: 'yellow',
  OWNER: 'green',
  RENTER: 'blue',
  MEMBER: 'violet',
  GUEST: 'cyan',
  OTHER: 'gray',
}

export const berthStatusColor: Record<string, string> = {
  AVAILABLE: 'green',
  OCCUPIED: 'blue',
  RESERVED: 'teal',
  MAINTENANCE: 'gray',
  BLOCKED: 'red',
}

export const assignmentPriorityColor: Record<string, string> = {
  LOW: 'gray',
  MEDIUM: 'yellow',
  HIGH: 'orange',
  URGENT: 'red',
}

export const assignmentStatusColor: Record<string, string> = {
  PENDING: 'yellow',
  IN_PROGRESS: 'blue',
  COMPLETED: 'green',
  BLOCKED: 'red',
  CANCELLED: 'gray',
}

export const inventoryThresholdColor: Record<string, string> = {
  GOOD: 'green',
  LOW: 'yellow',
  OUT: 'red',
}

export type MarinaStatusKind =
  | 'booking'
  | 'quote'
  | 'invoice'
  | 'contract'
  | 'berth'
  | 'assignmentStatus'
  | 'assignmentPriority'
  | 'customerCategory'
  | 'inventoryThreshold'

export const statusColorMap: Record<MarinaStatusKind, Record<string, string>> = {
  booking: bookingStatusColor,
  quote: quoteStatusColor,
  invoice: invoiceStatusColor,
  contract: contractStatusColor,
  berth: berthStatusColor,
  assignmentStatus: assignmentStatusColor,
  assignmentPriority: assignmentPriorityColor,
  customerCategory: customerCategoryColor,
  inventoryThreshold: inventoryThresholdColor,
}
